// @ts-strict-ignore
import React, {
  type CSSProperties,
  type ComponentType,
  type ReactNode,
} from 'react';
import { Trans } from 'react-i18next';

import { Text } from '../../../common/Text';
import { View } from '../../../common/View';
import { type SheetFields, type Binding } from '../../../spreadsheet';
import { CellValue, CellValueText } from '../../../spreadsheet/CellValue';

type BudgetTotalProps<
  CurrentField extends SheetFields<'tracking-budget'>,
  TargetField extends SheetFields<'tracking-budget'>,
> = {
  title: ReactNode;
  current: Binding<'tracking-budget', CurrentField>;
  target: Binding<'tracking-budget', TargetField>;
  ProgressComponent: ComponentType<{ current; target }>;
  style?: CSSProperties;
};
export function BudgetTotal<
  CurrentField extends SheetFields<'tracking-budget'>,
  TargetField extends SheetFields<'tracking-budget'>,
>({
  title,
  current,
  target,
  ProgressComponent,
  style,
}: BudgetTotalProps<CurrentField, TargetField>) {
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        fontSize: 13,
        ...style,
      }}
    >
      <Text className="text-muted-foreground">{title}</Text>
      <Text style={{ fontFeatureSettings: '"tnum"' }}>
        <Trans
          i18nKey="<allocatedAmount /> <italic>of <totalAmount /></italic>"
          components={{
            allocatedAmount: <CellValue binding={current} type="financial" />,
            italic: (
              <Text
                className="text-muted-foreground"
                style={{ fontStyle: 'italic', marginLeft: 2 }}
              />
            ),
            totalAmount: (
              <CellValue binding={target} type="financial">
                {props => (
                  <CellValueText {...props} style={{ fontFeatureSettings: '' }} />
                )}
              </CellValue>
            ),
          }}
        />
      </Text>
    </View>
  );
}
